/**
 * Prefetch de chunks lazy ao passar o mouse / focar em links.
 * Reduz drasticamente o tempo entre clique e renderização da página.
 *
 * Uso:
 *   const handlers = usePrefetchOnHover(() => import("@/pages/Painel"));
 *   <a {...handlers} onClick={...}>Painel</a>
 */
import { useRef, useCallback } from "react";

type Importer = () => Promise<unknown>;

const triggered = new WeakSet<Importer>();

export function prefetch(importer: Importer) {
  if (triggered.has(importer)) return;
  triggered.add(importer);
  // Inicia o download mas ignora erros (será tratado pelo lazyRetry no clique real)
  importer().catch(() => triggered.delete(importer));
}

export function usePrefetchOnHover(importer: Importer) {
  const ref = useRef(importer);
  ref.current = importer;

  const trigger = useCallback(() => prefetch(ref.current), []);

  return {
    onMouseEnter: trigger,
    onFocus: trigger,
    onTouchStart: trigger,
  };
}
